import { X } from 'lucide-react';

interface ClearFiltersButtonProps {
  onClear: () => void;
}

export default function ClearFiltersButton({ onClear }: ClearFiltersButtonProps) {
  return (
    <div className="flex-shrink-0">
      <button
        onClick={onClear}
        className="group flex items-center gap-1.5 whitespace-nowrap rounded-md border border-white/20 px-3 py-1.5 text-xs font-medium text-slate-400 transition-all duration-200 hover:border-red-500/40 hover:bg-red-600/10 hover:text-red-300"
        style={{ backgroundColor: '#454b4d' }}
        title="Clear all active filters"
      >
        <X size={14} className="opacity-70 group-hover:opacity-100" />
        Clear All
      </button>
    </div>
  );
}
